var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',{staticClass:"el-header"},[_c('Top')],1),_vm._v(" "),_c('el-container',{staticClass:"el-container"},[_c('el-aside',{staticClass:"el-aside",attrs:{"width":"200px"}},[_c('Menu')],1),_vm._v(" "),_c('el-container',[_c('el-main',{staticClass:"el-main"},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d010186","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MyMain.vue
// module id = null
// module chunks = 